import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 6"
      portada="https://fullcomics18.org/img7/touchuukasou6-1.jpg"
     paginas={[
  "https://fullcomics18.org/img7/touchuukasou6-1.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-2.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-3.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-4.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-5.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-6.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-7.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-8.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-9.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-10.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-11.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-12.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-13.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-14.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-15.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-16.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-17.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-18.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-19.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-20.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-21.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-22.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-23.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-24.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-25.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-26.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-27.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-28.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-29.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-30.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-31.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-32.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-33.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-34.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-35.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-36.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-37.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-38.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-39.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-40.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-41.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-42.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-43.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-44.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-45.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-46.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-47.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-48.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-49.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-50.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-51.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-52.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-53.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-54.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-55.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-56.jpg",
  "https://fullcomics18.org/img7/touchuukasou6-57.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Big Penis", "Bikini", "Blowjob", "C97", "Closed Eyes", "Collar", "Cunnilingus", "Dog Girl", "Exhibitionism", "Fingering", "Freckles", "Huge Breasts", "Kemonomimi", "Kissing", "Masturbation", "Multi-work Series", "Nakadashi", "Netorare", "Petplay", "Sex Toys", "Shaved Head", "Swimsuit", "Tail Plug", "Tall Girl", "Voyeurism", "X-Ray"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 6",
  portada: "https://fullcomics18.org/img7/touchuukasou6-1.jpg",
  reverso: "https://fullcomics18.org/img7/touchuukasou6-10.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Big Penis", "Bikini", "Blowjob", "C97", "Closed Eyes", "Collar", "Cunnilingus", "Dog Girl", "Exhibitionism", "Fingering", "Freckles", "Huge Breasts", "Kemonomimi", "Kissing", "Masturbation", "Multi-work Series", "Nakadashi", "Netorare", "Petplay", "Sex Toys", "Shaved Head", "Swimsuit", "Tail Plug", "Tall Girl", "Voyeurism", "X-Ray"],
    artistas: "Fuetakishi",
  },
};
